import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../../../../../modules/shared/services/shared.service";

import { ActivatedRoute } from "@angular/router";

@Component({
    selector: "template-config",
    templateUrl: "./template-config.view.html",
    providers: []
})
export class TemplateConfigView implements OnInit {
    selectedLayout = "l_circular";
    baseUrl = "";
    isCard = false;

    templateStyles: any = [
        {
            label: "Layout w/ Circular Image",
            code: "l_circular"
        },
        {
            label: "Layout without Image",
            code: "l_noimage"
        },
        {
            label: "Layout w/ Square Image",
            code: "l_square"
        },
        {
            label: "Layout w/ Banner Image",
            code: "l_banner"
        }
    ];

    constructor(public sharedService: SharedService, private activatedRoute: ActivatedRoute) {
        this.baseUrl = sharedService.sessionUrl;
        if (this.activatedRoute.parent.routeConfig.path == "speaker-sessions") {
            this.selectedLayout = this.sharedService.sessionLayoutConfig.layout;
        } else if (this.activatedRoute.parent.routeConfig.path == "speaker") {
            this.selectedLayout = this.sharedService.speakerLayoutConfig[this.baseUrl].layout;
            var layoutConfig = JSON.parse(this.sharedService.setup.layoutConfig);
            if (
                (this.baseUrl === "highlighted" && layoutConfig.vipUnit === "card") ||
                (this.baseUrl === "general" && layoutConfig.listType === "card")
            ) {
                this.isCard = true;
            }
        }
    }

    ngOnInit() {}

    changeTemplate(selectedLayout) {
        this.selectedLayout = selectedLayout;
        if (this.activatedRoute.parent.routeConfig.path == "speaker-sessions") {
            this.sharedService.sessionLayoutConfig.layout = selectedLayout;
        } else if (this.activatedRoute.parent.routeConfig.path == "speaker") {
            this.sharedService.speakerLayoutConfig[this.baseUrl].layout = selectedLayout;
        }
    }
}
